import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faArrowLeft, faHome, faBoxOpen, faTrash, faPaperPlane, faUser, faCircleInfo, faCreditCard, faMoneyBill, faTruck } from '@fortawesome/free-solid-svg-icons';
import { faWhatsappSquare } from '@fortawesome/free-brands-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import MiPedido from '../MiPedido/MiPedido'
import MercadoPago from '../MercadoPago/MercadoPago'
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    useEffect(() => { try { Modal.setAppElement('#root'); } catch(_){} }, []);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [tienda, setTienda] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [metodos, setMetodos] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [pagoRecibir, setPagoRecibir] = useState('');
    const [estado, setEstado] = useState(null);
    let now = new Date();
    // Obtener la diferencia de zona horaria en minutos ((Colombia es GMT-5)
    let offset = -5 * 60; // Colombia  está a GMT-3
    // Ajustar la fecha actual sumando/restando el offset
    let colombiaTime = new Date(now.getTime() + offset * 60 * 1000);
    // Formatear la fecha a 'YYYY-MM-DD HH:MM:SS'
    let createdAt = colombiaTime.toISOString().slice(0, 19).replace('T', ' ');

    // 3. Estados para el modal de WhatsApp (reutilizando lógica)
    const [modalWhatsApp, setModalWhatsApp] = useState(false);
    const [whatsappMessage, setWhatsappMessage] = useState('¡Hola! Estoy interesado en...');


    const [address, setAddress] = useState('');
    useEffect(() => {
        cargarTienda()
    }, []);
    useEffect(() => {
        // Calcular el precio total usando itemsDetailed si existe
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            const units = (Array.isArray(item?.itemsDetailed) && item.itemsDetailed.length > 0)
                ? item.itemsDetailed.reduce((s, d) => s + (parseInt(d?.qty || 0, 10) || 0), 0)
                : (item?.cantidad || 0);
            totalPriceCalc += (item?.precio || 0) * units;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    useEffect(() => {
        const fetchEstado = async () => {
            try {
                const response = await fetch(`${baseURL}/estado.php?`);
                const data = await response.json();
                if (data.error) {
                    console.error(data.error);
                } else {
                    setEstado(data.estado);
                }
            } catch (error) {
                console.error("Error al obtener el estado:", error);
            }
        };

        fetchEstado();
    }, []);

    useEffect(() => {
        const onOpenCart = () => { if (!window.__cartOpen) { window.__cartOpen = true; setModalIsOpen(true); setIsFocused(true); } };
        const onCloseAll = () => { setModalIsOpen(false); setModalIsOpen2(false); setModalWhatsApp(false); window.__cartOpen = false; setIsFocused(false); };
        const onCartUpdated = () => { try{ setIsFocused(true); cargarProductos(); }catch(_){ } };
        window.addEventListener('open-cart', onOpenCart);
        window.addEventListener('close-all-overlays', onCloseAll);
        window.addEventListener('cart-updated', onCartUpdated);
        return () => { window.removeEventListener('open-cart', onOpenCart); window.removeEventListener('close-all-overlays', onCloseAll); window.removeEventListener('cart-updated', onCartUpdated); };
    }, []);
    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse() || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    useEffect(() => {
        cargarMetodos();
        cargarProductos();
        const onStorage = (e) => { try{ if (e.key==='stockUpdateFlag'){ cargarProductos(); } }catch(_){ } };
        window.addEventListener('storage', onStorage);
        return () => { window.removeEventListener('storage', onStorage); };
    }, [isFocused]);

  useEffect(() => {
      const fetchCartItems = async () => {
          const cart = JSON.parse(localStorage.getItem('cart')) || [];
          const promises = cart.map(async (cartItem) => {
              const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
              return {
                  ...producto,
                  cantidad: cartItem.cantidad,
                  items: cartItem.items,
                  itemsDetailed: cartItem.itemsDetailed || null,
              };
          });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);



    const cargarMetodos = () => {
        fetch(`${baseURL}/metodoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // Filtra solo los métodos con estado "Activo"
                const metodosActivos = (data.metodos || [])?.filter(metodo => metodo.estado === 'Activo');
                setMetodos(metodosActivos);
                console.log(metodosActivos);
            })
            .catch(error => console.error('Error al cargar datos bancarios:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, { method:'GET' })
            .then(r=>r.text())
            .then(t=>{ try{ const data=JSON.parse(t); setProductos(data.productos||[]); }catch(_){ setProductos([]);} })
            .catch(()=>{});
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        if (window.__cartOpen) return;
        window.__cartOpen = true;
        setModalIsOpen(true);
        setIsFocused(true);
        try{ window.dispatchEvent(new Event('open-cart')); }catch(_){ }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
        window.__cartOpen = false;
        try{ window.dispatchEvent(new Event('close-all-overlays')); }catch(_){ }
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        try{ window.dispatchEvent(new Event('cart-updated')); }catch(_){ }
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
        try{ window.dispatchEvent(new Event('cart-updated')); }catch(_){ }
    };

    const [codigos, setCodigos] = useState([]);
    const [discountInfo, setDiscountInfo] = useState({ aplicable: false, amount: 0, percent: null, fixed: null });
    const [couponInfo, setCouponInfo] = useState({ ok: false, msg: '' });
    const [appliedCode, setAppliedCode] = useState('');

    useEffect(() => {
        cargarCodigos();

    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    const aplicarCupon = async () => {
        try {
            if (!codigo || cartItems.length === 0) { setDiscountInfo({ aplicable:false, amount:0, percent:null, fixed:null }); setCouponInfo({ ok:false, msg:'Código inválido' }); return; }
            const payload = {
                codigo,
                productos: cartItems.map(ci => ({ idProducto: ci.idProducto, idCategoria: ci.idCategoria, precio: ci.precio, cantidad: ci.cantidad }))
            };
            const r = await fetch(`${baseURL}/codigoValidate.php`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) });
            const d = await r.json();
            setDiscountInfo({ aplicable: !!d.aplicable, amount: Number(d.amount||0), percent: d.percent ?? null, fixed: d.fixed ?? null });
            if (d.aplicable) {
                setCouponInfo({ ok: true, msg: 'Cupón aplicado' });
                setAppliedCode(codigo);
            } else {
                let m = '';
                switch (d.reason) {
                    case 'invalid_code': m = 'Código no válido'; break;
                    case 'out_of_date': m = 'Código expirado o fuera de fecha'; break;
                    case 'limit_exceeded': m = 'Límite de usos alcanzado'; break;
                    case 'not_applicable': m = 'No aplica a tus productos'; break;
                    default: m = 'Código inválido';
                }
                setCouponInfo({ ok: false, msg: m });
            }
        } catch(_){ setDiscountInfo({ aplicable:false, amount:0, percent:null, fixed:null }); setCouponInfo({ ok:false, msg:'Error validando cupón' }); }
    };

    const quitarCupon = () => {
        setCodigo('');
        setDiscountInfo({ aplicable:false, amount:0, percent:null, fixed:null });
        setCouponInfo({ ok:false, msg:'' });
        setAppliedCode('');
    };

    useEffect(() => {
        if (!codigo) { setDiscountInfo({ aplicable:false, amount:0, percent:null, fixed:null }); setCouponInfo({ ok:false, msg:'' }); }
    }, [codigo]);
    const handleWhatsappMessage = (data) => {
        const { idPedido, nombre, telefono, entrega, pago, codigo, total, nota, productos, pagoRecibir } = data;

        const formattedTotalPrice = total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const d = String(tienda[0]?.telefono||'').replace(/\D+/g,'');
        const phoneNumber = d;

        // Formatear los detalles de los productos
        const productosDetails = productos.map(item => {
            return `\n✅ *${item.titulo}* \n      Precio: ${moneda} ${item?.precio?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}  x  ${item.cantidad}\n      ${item.items}\n`;
        }).join('');

        const message = `¡Hola! 🌟 Mi pedido es el N°${idPedido}\n${productosDetails}\n👤 Nombre: ${nombre}\n\n📱 Teléfono: ${telefono}\n\n📦 Entrega: ${entrega}\n\n💵 Forma de pago: ${pago}\n\n📌 Pago al recibirlo: ${pagoRecibir}\n\n🏷 Código de descuento: ${codigo}\n\n✅ Nota: ${nota}\n\n*Total: ${moneda} ${formattedTotalPrice}*`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');

        // Limpiar estados (opcional, dependiendo de tu lógica)
        setName('');
        setLocation('');
        setNoteText('');
        setCodigo('');
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };





    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        const item = updatedCartItems[index];
        const hasVars = Array.isArray(item?.itemsDetailed) && item.itemsDetailed.length > 0;
        if (hasVars) { return; }
        const st = String(item?.status||'').toLowerCase();
        let total = parseInt(item?.stock||0,10)||0;
        try { const q = JSON.parse(item?.itemsQty||'[]'); if (Array.isArray(q)) { for (let i=0;i<Math.min(10,q.length);i++){ total += parseInt(q[i]||0,10)||0; } } } catch(_){ }
        const isUnlimited = (st === 'disponible') && (total === 0);
        if (isUnlimited) {
            item.cantidad += 1;
        } else {
            const next = item.cantidad + 1;
            item.cantidad = next > total ? total : next;
            if (next > total) { try{ toast.warn('Alcanzaste el máximo disponible'); }catch(_){ } }
        }
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        setMensaje('Procesando...');

        try {
            const sanitized = cartItems.map(ci => {
                const st = String(ci?.status||'').toLowerCase();
                let total = parseInt(ci?.stock||0,10)||0;
                try { const q = JSON.parse(ci?.itemsQty||'[]'); if (Array.isArray(q)) { for (let i=0;i<Math.min(10,q.length);i++){ total += parseInt(q[i]||0,10)||0; } } } catch(_){ }
                const isUnlimited = (st === 'disponible') && (total === 0);
                if (Array.isArray(ci?.itemsDetailed) && ci.itemsDetailed.length>0) { return ci; }
                if (isUnlimited) { return ci; }
                const qty = parseInt(ci?.cantidad||1,10)||1;
                const clamped = Math.min(qty, total);
                if (clamped !== qty) { try{ toast.warn('Cantidad ajustada por stock'); }catch(_){ } }
                return { ...ci, cantidad: clamped };
            });
            setCartItems(sanitized);
            localStorage.setItem('cart', JSON.stringify(sanitized));

            // Construir la lista de productos del pedido
            const productosPedido = sanitized?.map(item => {
                return {
                    idProducto: item?.idProducto,
                    idCategoria: item.idCategoria,
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    items: item?.items,
                    itemsDetailed: item?.itemsDetailed || null,
                    imageIndex: item?.imageIndex || null,
                    precio: item?.precio,
                    imagen: obtenerImagen(item)
                };
            });

            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);

            let totalPrice = 0;
            sanitized.forEach(item => {
                const units = (Array.isArray(item?.itemsDetailed) && item.itemsDetailed.length > 0)
                    ? item.itemsDetailed.reduce((s, d) => s + (parseInt(d?.qty || 0, 10) || 0), 0)
                    : (item?.cantidad || 0);
                totalPrice += (item?.precio || 0) * units;
            });
            if (discountInfo?.aplicable) { totalPrice = Math.max(0, totalPrice - Number(discountInfo.amount||0)); }

            // Confirmación previa con resumen del pedido
            const resumenHTML = cartItems.map(ci => {
                const base = `${ci.titulo} – ${moneda} ${String(ci.precio||0).replace(/\B(?=(\d{3})+(?!\d))/g, ".")} x ${ci.cantidad}`;
                if (Array.isArray(ci.itemsDetailed) && ci.itemsDetailed.length>0){
                    const vars = ci.itemsDetailed.map(d=>`${d.name} x ${d.qty}`).join(', ');
                    return `${base}<br/><small>${vars}</small>`;
                } else if (Array.isArray(ci.items) && ci.items.length>0){
                    return `${base}<br/><small>${ci.items.join(', ')}</small>`;
                }
                return base;
            }).join('<hr/>');
            const confirm = await Swal.fire({
                title: 'Confirmar pedido',
                html: `${resumenHTML}<hr/><strong>Total:</strong> ${moneda} ${String(totalPrice||0).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
                showCancelButton: true,
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Modificar',
            });
            if (!confirm?.isConfirmed){ setMensaje(''); return; }

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();
            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPrice);
            formData.append('nombre', name);
            formData.append('telefono', telefono);

            const entrega = deliveryOption === 'delivery' ? address : 'Retiro en Sucursal';
            formData.append('entrega', entrega);
            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Solicitado');
            formData.append('pagado', 'No');
            formData.append('pagoRecibir', pagoRecibir);
            formData.append('createdAt', createdAt);

            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.idPedido) {
                setMensaje('');
                Swal.fire(
                    'Pedido enviado!',
                    `Pedido N°${data.idPedido} creado con éxito.`,
                    'success'
                );

                // Aquí pasamos los datos necesarios a handleWhatsappMessage
                handleWhatsappMessage(data);
                // Guardar el idPedido en localStorage
                localStorage.setItem('idPedido', data.idPedido);
                try{ localStorage.setItem('stockUpdateFlag', String(Date.now())); window.dispatchEvent(new Event('stock-updated')); }catch(_){ }
                // Limpiar campos y cerrar modal
                setName('');
                setCodigo('');
                setNoteText('');
                closeModal();
                closeModal2();
                clearCart();
            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );
        }
    };

    useEffect(() => {
        if (metodos && metodos.length > 0) {
            setPaymentMethod(metodos[0].tipo);
        }
    }, [metodos]);

    const handlePaymentChange = (metodo) => {
        setPaymentMethod(metodo);
        if (metodo === 'Transferencia') {
            setPagoRecibir('Si'); // Valor predeterminado "Sí" para Transferencia
        } else {
            setPagoRecibir(''); // Borra el valor si no es Transferencia
        }
    };
    const handlePagoRecibirChange = (value) => {
        setPagoRecibir(value);
    };

    // 3. Lógica para el modal de WhatsApp
    const openWhatsAppModal = () => setModalWhatsApp(true);
    const closeWhatsAppModal = () => setModalWhatsApp(false);

    const sendWhatsAppMessage = () => {
        const d = String(tienda[0]?.telefono||'').replace(/\D+/g,'');
        const phoneNumber = d;
        const message = whatsappMessage || 'Hola, ¿en qué podemos ayudarte? 👋';
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
        closeWhatsAppModal();
        setWhatsappMessage('¡Hola! Estoy interesado en...');
    };

    return (
        <div>
            <button onClick={openModal} className='cartIconFixed'>
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )

                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            {/* Barra de navegación inferior duplicada eliminada para evitar redundancia con NavbarMobile */}

            {/* --- 3. NUEVO MODAL DE WHATSAPP --- */}
            <Modal isOpen={modalWhatsApp} className="modal-cart" overlayClassName="overlay-cart" onRequestClose={closeWhatsAppModal} ariaHideApp={false}>
                <div className='deFLex'>
                    <button onClick={closeWhatsAppModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                    <h4>Contactar por WhatsApp</h4>
                    <div />
                </div>
                <div className="modal-send-form" style={{ justifyContent: 'space-between' }}>
                    <div>
                        <div style={{ backgroundColor: '#f0f0f0', padding: '15px', borderRadius: '10px', marginBottom: '20px' }}>
                            <p style={{ margin: '0', color: '#333' }}>Hola, ¿en qué podemos ayudarte? 👋</p>
                        </div>
                        <textarea
                            value={whatsappMessage}
                            onChange={(e) => setWhatsappMessage(e.target.value)}
                            placeholder="Escribe tu mensaje..."
                            style={{
                                width: '100%',
                                minHeight: '120px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '10px',
                                fontSize: '16px',
                                resize: 'vertical'
                            }}
                        />
                    </div>
                    <button onClick={sendWhatsAppMessage} className='btn' style={{ backgroundColor: '#25D366' }}>
                        Enviar Mensaje
                        <FontAwesomeIcon icon={faPaperPlane} />
                    </button>
                </div>
            </Modal>


            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
                ariaHideApp={false}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <MiPedido />
                </div>


                {
                    estado === 'Abierto' ? (
                        <>
                            {cartItems?.length === 0 ?
                                (<p className='nohay'> No hay productos</p>)
                                : (<>
                                    <div className="modal-content-cart">


                                        {loading ? (
                                            <p>Cargando...</p>
                                        ) : (
                                            <div>

                                                {/* Progreso de compra */}
                                                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8, marginBottom:12 }}>
                                                  {['Carrito','Datos','Pago'].map((step, i)=>{
                                                    const active = (i===0) || (i===1 && name && telefono) || (i===2 && paymentMethod);
                                                    return (
                                                      <div key={step} style={{ padding:'8px 10px', borderRadius:10, border:'1px solid #eee', background: active ? '#e8f0fe' : '#f7f7f7', color: active ? '#1d4ed8' : '#6b7280', textAlign:'center' }}>{step}</div>
                                                    );
                                                  })}
                                                </div>

                                                {cartItems.map((item, index) => (
                                                    <div key={item?.idProducto} className='cardProductCart' >
                                                        <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                            <img src={(obtenerImagen(item) && /^https?:/i.test(obtenerImagen(item))) ? obtenerImagen(item) : `${baseURL}/${String(obtenerImagen(item)||'').replace(/^\//,'')}`} alt="imagen" />
                                                        </Anchor>
                                                        <div className='cardProductCartText'>
                                                            <h3>{item.titulo}</h3>
                                                            <span>
                                                              {Array.isArray(item.itemsDetailed) && item.itemsDetailed.length>0 ? (
                                                                item.itemsDetailed.map((d, di)=>(<span key={di}>{d.name} x {d.qty}{di<item.itemsDetailed.length-1?', ':''}</span>))
                                                              ) : (
                                                                item?.items?.map((sabor, index) => (<span key={index}>{sabor}{index<item.items.length-1?', ':''}</span>))
                                                              )}
                                                            </span>
                                                            <strong>{moneda} {item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                                                        </div>
                                                        <div className='deColumn'>
                                                            <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                            <div className='deFlexCantidad'>
                                                                <button onClick={() => decreaseQuantity(index)}>-</button>
                                                                <span>{item.cantidad}</span>
                                                                <button onClick={() => increaseQuantity(index)}>+</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className='deColumnCart'>
                                            <div className='cart-total-row'>
                                                <h4>Total: {moneda} {(() => {
                                                    const base = cartItems.reduce((acc, it) => {
                                                        const units = (Array.isArray(it?.itemsDetailed) && it.itemsDetailed.length > 0)
                                                            ? it.itemsDetailed.reduce((s, d) => s + (parseInt(d?.qty || 0, 10) || 0), 0)
                                                            : (it?.cantidad || 0);
                                                        return acc + ((it?.precio || 0) * units);
                                                    }, 0);
                                                    const withDiscount = discountInfo?.aplicable ? Math.max(0, base - Number(discountInfo.amount || 0)) : base;
                                                    return String(withDiscount).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                                })()}</h4>
                                                {discountInfo?.aplicable && (
                                                    <span style={{ color: '#0a7a0a' }}>Descuento aplicado: -{moneda} {String(Number(discountInfo.amount||0)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
                                                )}
                                                <button className='btnWpp' onClick={openModal2}>
                                                    Pedir por WhatsApp<img src={whatsappIcon} alt="WhatsApp" />
                                                </button>
                                            </div>
                                    </div>

                                    <Modal
                                        isOpen={modalIsOpen2}
                                        onRequestClose={closeModal2}
                                        className="modal-cart"
                                        overlayClassName="overlay-cart"
                                        ariaHideApp={false}
                                    >
                                        <div className='deFLex'>
                                            <button onClick={closeModal2} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                            <h4>(*) Campos obligatorios</h4>
                                        </div>
                                        <div className="modal-send-form">
                                            <input
                                                type="text"
                                                id="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                placeholder='Apellido y Nombre (*)'
                                            />

                                            {(() => { const digits = String(telefono||'').replace(/\D+/g,''); const valid = digits.length >= 10; return (
                                              <div>
                                                <input
                                                    type="tel"
                                                    id="telefono"
                                                    value={telefono}
                                                    onChange={(e) => setTelefono(e.target.value)}
                                                    placeholder='Telefono / WhatsApp (*)'
                                                    style={{ borderColor: valid ? '#ddd' : '#ef4444' }}
                                                />
                                                {!valid && (<div style={{ color:'#ef4444', fontSize:12, marginTop:4 }}>Ingresa al menos 10 dígitos</div>)}
                                              </div>
                                            ); })()}
                                            <div className='deFLexRadio'>
                                                <label>Opciones de entrega (*)</label>

                                                <div
                                                    onClick={() => setDeliveryOption('delivery')}
                                                >
                                                    <input
                                                        type="radio"
                                                        id="delivery"
                                                        name="deliveryOption"
                                                        value="delivery"
                                                        checked={deliveryOption === 'delivery'}
                                                        onChange={() => setDeliveryOption('delivery')}
                                                    />
                                                    <label htmlFor="delivery">Envío a domicilio</label>
                                                </div>

                                                <div
                                                    onClick={() => setDeliveryOption('pickup')}
                                                >
                                                    <input
                                                        type="radio"
                                                        id="pickup"
                                                        name="deliveryOption"
                                                        value="pickup"
                                                        checked={deliveryOption === 'pickup'}
                                                        onChange={() => setDeliveryOption('pickup')}
                                                    />
                                                    <label htmlFor="pickup">Retiro en Sucursal</label>
                                                </div>

                                                <div
                                                    onClick={() => setDeliveryOption('pickup')}
                                                >
                                                    <input
                                                        type="radio"
                                                        id="pickup"
                                                        name="deliveryOption"
                                                        value="pickup"
                                                        checked={deliveryOption === 'pickup'}
                                                        onChange={() => setDeliveryOption('pickup')}
                                                    />
                                                    <label htmlFor="pickup">Envío Digital/Online</label>
                                                </div>


                                            </div>
                                            {deliveryOption === 'delivery' && (

                                                <input
                                                    type="text"
                                                    id="address"
                                                    name="address"
                                                    value={address}
                                                    onChange={(e) => setAddress(e.target.value)}
                                                    placeholder="Dirección / Nro. (*)"
                                                />

                                            )}
                                            <div className='deFLexRadio'>
                                                <label>Formas de pago (*)</label>
                                                {metodos?.map(metodo => (
                                                    <section key={metodo.idMetodo} className='columnRadio'>
                                                        <div>
                                                            <input
                                                                type="radio"
                                                                name="paymentMethod"
                                                                id={metodo.tipo}
                                                                value={metodo.tipo}
                                                                checked={paymentMethod === metodo.tipo}
                                                                onChange={() => handlePaymentChange(metodo.tipo)}
                                                            />
                                                            <label htmlFor={metodo.tipo} style={{ display:'inline-flex', alignItems:'center', gap:8 }}>
                                                                {(() => { const t = metodo.tipo || ''; if (/Tarjeta/i.test(t)) return (<FontAwesomeIcon icon={faCreditCard} />); if (/Transferencia/i.test(t)) return (<FontAwesomeIcon icon={faMoneyBill} />); if (/Retiro|Contraentrega|Envío|Envio/i.test(t)) return (<FontAwesomeIcon icon={faTruck} />); return (<FontAwesomeIcon icon={faCircleInfo} />); })()}
                                                                <span>{metodo.tipo}</span>
                                                            </label>
                                                        </div>

                                                        {paymentMethod === 'Transferencia' && metodo.tipo === 'Transferencia' && (
                                                            <section className='radioRecibi'>
                                                                <label htmlFor="">Pago al recibirlo</label>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        name="pagoRecibir"
                                                                        id="Sí"
                                                                        value="Si"
                                                                        checked={pagoRecibir === 'Si'}
                                                                        onChange={() => handlePagoRecibirChange('Si')}
                                                                    />
                                                                    <label htmlFor="Sí">Sí</label>
                                                                </div>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        name="pagoRecibir"
                                                                        id="No"
                                                                        value="No"
                                                                        checked={pagoRecibir === 'No'}
                                                                        onChange={() => handlePagoRecibirChange('No')}
                                                                    />
                                                                    <label htmlFor="No">No (envío comprobante)</label>
                                                                </div>
                                                            </section>
                                                        )}
                                                    </section>
                                                ))}


                                            </div>
                                            {metodos?.length > 0 && metodos?.some(m => m.tipo === paymentMethod) ? (
                                                <>
                                                    {metodos
                                                        ?.filter(metodo => metodo.tipo === paymentMethod)
                                                        ?.map(datos => (
                                                            < >
                                                                {
                                                                    (datos?.tipo === 'Tarjeta credito / debito') ? (
                                                                        (datos?.datos && !String(datos?.datos).includes('accessToken') && !String(datos?.datos).includes('publicKey')) ? (
                                                                            <div className='deFLexRadioMetod' >
                                                                                <span key={datos.idDatos}>
                                                                                    {datos.datos}
                                                                                </span>
                                                                            </div>
                                                                        ) : (<></>)
                                                                    ) : (
                                                                        datos?.datos === '' ? (
                                                                            <></>
                                                                        ) : (
                                                                            <div className='deFLexRadioMetod' >
                                                                                <span key={datos.idDatos}>
                                                                                    {datos.datos}
                                                                                </span>
                                                                            </div>
                                                                        )
                                                                    )
                                                                }
                                                            </>
                                                        ))}
                                                    {paymentMethod === 'Tarjeta credito / debito' && (
                                                        <div style={{ marginTop: '12px' }}>
                                                            <span style={{ display: 'block', marginBottom: '6px', color: '#555' }}>Paga con tarjeta de crédito/débito:</span>
                                                            <MercadoPago
                                                                items={cartItems}
                                                                payerEmail={tienda[0]?.email || ''}
                                                                order={{
                                                                    productos: cartItems.map(ci => ({
                                                                        idProducto: ci.idProducto,
                                                                        idCategoria: ci.idCategoria,
                                                                        titulo: ci.titulo,
                                                                        cantidad: ci.cantidad,
                                                                        items: ci.items,
                                                                        itemsDetailed: ci.itemsDetailed || null,
                                                                        imageIndex: ci.imageIndex ?? null,
                                                                        precio: ci.precio,
                                                                    })),
                                                                    total: totalPrice,
                                                                    nombre: name,
                                                                    telefono: telefono,
                                                                    entrega: (deliveryOption === 'delivery' ? address : (deliveryOption === 'pickup' ? 'Retiro en Sucursal' : '')),
                                                                    nota: noteText,
                                                                    codigo: codigo,
                                                                    pagoRecibir: pagoRecibir,
                                                                    createdAt: createdAt,
                                                                }}
                                                                discountInfo={discountInfo}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            ) : null}



                                            <input
                                                type="text"
                                                id="codigo"
                                                value={codigo}
                                                onChange={(e) => setCodigo(e.target.value)}
                                                placeholder='Codigo de descuento (opcional)'
                                            />
                                            <button
                                                type='button'
                                                onClick={aplicarCupon}
                                                className='btn'
                                                style={{ marginTop: '6px' }}
                                                disabled={!codigo || (couponInfo.ok && appliedCode === codigo)}
                                                title={!codigo ? 'Ingresa un código' : ((couponInfo.ok && appliedCode === codigo) ? 'Ya aplicado' : 'Aplicar')}
                                            >
                                                Aplicar
                                            </button>
                                            {codigo && (
                                                couponInfo.ok ? (
                                                    <div style={{ display:'flex', alignItems:'center', gap:'8px', color: '#0a7a0a', marginTop: '4px' }}>
                                                        <FontAwesomeIcon icon={faCircleInfo} />
                                                        <span>{couponInfo.msg}</span>
                                                        <button type='button' onClick={quitarCupon} className='btn' style={{ background:'#999' }}>Quitar cupón</button>
                                                    </div>
                                                ) : (
                                                    couponInfo.msg && <div style={{ color: '#b00020', marginTop: '4px' }}>{couponInfo.msg}</div>
                                                )
                                            )}
                                            <textarea
                                                placeholder="Agrega aquí detalles o solicitudes del pedido (Opcional)"
                                                value={noteText}
                                                onChange={(e) => setNoteText(e.target.value)}
                                            />
                                            <fieldset className='deNonefieldset'>
                                                <legend>Productos</legend>
                                                <textarea
                                                    name='productos'
                                                    value={cartItems.map(item => `${item.titulo}, x ${item.cantidad}, ${item.items}, ${item.precio}, ${obtenerImagen(item)}  `).join('\n')}
                                                    readOnly
                                                />
                                            </fieldset>


                                        </div>
                                        {paymentMethod === 'Tarjeta credito / debito' ? (
                                            <div style={{ marginTop: '8px', color: '#666', fontSize: '0.9em' }}>El botón de pago de Mercado Pago abrirá el checkout.</div>
                                        ) : (
                                            mensaje ? (
                                                <button type='button' className='btn' disabled>{mensaje}</button>
                                            ) : (
                                                    <button type='button' onClick={crearPedido} className='btn'>
                                                        Finalizar pedido<img src={whatsappIcon} alt="WhatsApp" />
                                                    </button>
                                            )
                                        )}
                                   </Modal>

                                </>)}
                        </>
                    ) : (
                        <p className='nohay'>El establecimiento se encuentra <br />cerrado en estos momentos. <br />Consulte por horarios de atención.</p>
                    )
                }

            </Modal>
        </div >
    );
}
